import { FC, useEffect, useState, useCallback } from "react";
import { useBucketContext } from "context/bucket";
import { Modal } from "react-bootstrap";
import { PreviewModalProps } from "../../types";
import Image from "react-bootstrap/Image";
import { LoadingSpinner } from "components";

type ImageObject = { url: string; name: string };

export const PreviewModal: FC<PreviewModalProps> = (props) => {
  const { config, onClose } = props;
  const { getPresignedUrl } = useBucketContext();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState<ImageObject | null>(null);
  const [pdf, setPdf] = useState<string | null>(null);
  const [url, setUrl] = useState<string | null>(null);

  const blobToURL = (blob: Blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  };

  const pdfFactory = useCallback(async (url: string) => {
    const res = await fetch(url);
    const blob = await res.blob();
    const newBlob = new Blob([blob], { type: "application/pdf" });
    const blobUrl = await blobToURL(newBlob);
    return blobUrl;
  }, []);

  const fileFactory = useCallback(async () => {
    if (config) {
      const { fileName, fileExtensionType } = config;
      setLoading(true);
      const url = await getPresignedUrl(config);
      if (url) {
        setUrl(url);
        if (fileExtensionType === "image") {
          url && setImage({ url, name: fileName });
        } else {
          const blobUrl = await pdfFactory(url);
          setPdf(blobUrl as string);
        }
      }
      setLoading(false);
    }
  }, [config, getPresignedUrl, pdfFactory]);

  useEffect(() => {
    fileFactory();
    return () => {};
  }, [config, fileFactory]);

  const onHide = () => {
    setImage(null);
    setPdf(null);
    onClose();
  };

  return (
    <Modal
      show={Boolean(config)}
      onHide={onHide}
      fullscreen={config?.fileExtensionType === "pdf" ? true : "lg-down"}
      size="xl"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>{config?.fileName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {pdf ? (
          <object id="pdf_view" data={pdf} width={"100%"} height={"100%"}>
            <p>
              Il tuo web browser non ha il plugin per visualizzare il pdf. In
              alternativa, puoi&nbsp;
              <a href={url || ""} target="_blank" rel="noreferrer">
                cliccare qui per scaricare il file pdf (
                <strong>{config?.fileName}</strong>).
              </a>
            </p>
          </object>
        ) : null}
        {loading ? (
          <LoadingSpinner />
        ) : image ? (
          <Image src={image.url} alt={image.name} fluid />
        ) : null}
      </Modal.Body>
    </Modal>
  );
};
